(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["hb-crud-x"] = factory();
	else
		root["hb-crud-x"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 